import { ReorderCardContainer as ReorderCard } from 'components/features/components/simple-home-page/components/reorder-card';
import { useOrderStatusDetail } from 'components/order-status/use-order-status-details';
import { useServiceModeNotification } from 'components/top-service-mode-notification/hooks/use-service-mode-notification';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';

export const SimpleHomePageCardReorder = () => {
  const topServiceModeNotificationDetails = useServiceModeNotification();
  const orderStatusDetail = useOrderStatusDetail();
  const { logEvent } = useMParticleContext();

  // if we are showing, the service mode notification means that
  // the user has an order in place, so we should hide this card
  if (topServiceModeNotificationDetails || orderStatusDetail) {
    return null;
  }

  return (
    <ReorderCard
      openDetailEventMessage={CustomEventNames.LAST_ORDER_DETAILS}
      logViewEvent={() => {
        logEvent(CustomEventNames.LAST_ORDER_HOME_VIEW, EventTypes.Other);
      }}
      isAvailable={() => true}
      logReorderEvent={() => logEvent(CustomEventNames.LAST_ORDER_REORDER, EventTypes.Other)}
      logOpenDetailEvent={() => logEvent(CustomEventNames.LAST_ORDER_DETAILS, EventTypes.Other)}
    />
  );
};
